import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaShoppingCart } from 'react-icons/fa';

function PostCard({ post, onFavoriteToggle }) {
  const [showShareModal, setShowShareModal] = useState(false);

  const handleShare = () => {
    setShowShareModal(true);
    setTimeout(() => setShowShareModal(false), 2000);
  };

  return (
    <>
      <div className="post-card">
        <img src={post.image} alt={post.title} className="post-image" />
        <div className="post-content">
          <div className="post-date">
            <FaShoppingCart /> {post.date}
          </div>
          <h3>{post.title}</h3>
          <p>{post.excerpt}</p>
          <div className="post-actions">
            <Link to={`/post/${post.id}`} className="btn btn-primary">
              Διαβάστε Περισσότερα
            </Link>
            <button onClick={handleShare} className="btn btn-secondary">
              Κοινοποίηση
            </button>
            <button 
              onClick={() => onFavoriteToggle(post.id)} 
              className={`btn btn-favorite ${post.isFavorite ? 'active' : ''}`}
            >
              <FaHeart /> {post.isFavorite ? 'Αγαπημένο' : 'Προσθήκη'}
            </button>
          </div>
        </div>
      </div>

      {showShareModal && (
        <div className="modal">
          <div className="modal-content">
            <h2>Κοινοποίηση</h2>
            <p>Η λειτουργία κοινοποίησης θα είναι διαθέσιμη σύντομα!</p>
          </div>
        </div>
      )}
    </>
  );
}

export default PostCard;